import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-select';
import classNames from 'classnames';

import DropdownIndicator from './DropdownArrow';
import {
  mainDropdownStyles,
  mainDropdownTheme
} from 'styles/components/dropdown';

class DropdownComponent extends React.PureComponent {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any.isRequired,
        text: PropTypes.any.isRequired
      }).isRequired
    ).isRequired,

    className: PropTypes.string,
    value: PropTypes.any,
    isClearable: PropTypes.bool,
    onChange: PropTypes.func,
    styles: PropTypes.object,
    id: PropTypes.string,
    isDisabled: PropTypes.bool
  };

  static defaultProps = {
    isClearable: false
  };

  constructor (props) {
    super(props);

    this.state = {
      menuIsOpen: false
    };

    this.handleChange = data => {
      if (this.props.onChange) {
        this.props.onChange(data ? data.value : '');
      }
    };

    this.getValue = value => {
      const { options } = this.props;
      const chosenValue = options.find(option => option.value === value);
      if (chosenValue) {
        return { ...chosenValue, label: chosenValue.text };
      }
      return '';
    };

    this.getOptions = options =>
      options.map(option => {
        if (!option.label) {
          return { ...option, label: option.text };
        }
        return option;
      });
  }

  handleKeyDown = event => {
    if (event.keyCode === 13) {
      const { menuIsOpen } = this.state;

      this.setState({ menuIsOpen: !menuIsOpen });
    }
  };

  handleMenuOpen = () => {
    this.setState({ menuIsOpen: true });
  };

  handleMenuClose = () => {
    this.setState({ menuIsOpen: false });
  };

  render () {
    return (
      <div id={this.props.id}>
        <Dropdown
          {...this.props}
          menuIsOpen={this.state.menuIsOpen}
          onKeyDown={this.handleKeyDown}
          onMenuOpen={this.handleMenuOpen}
          onMenuClose={this.handleMenuClose}
          value={this.getValue(this.props.value)}
          options={this.getOptions(this.props.options)}
          components={{ DropdownIndicator }}
          theme={mainDropdownTheme}
          styles={this.props.styles ? this.props.styles : mainDropdownStyles}
          labelKey="text"
          isSearchable={false}
          onChange={this.handleChange}
          classNamePrefix="Select"
          className={classNames(
            'main-dropdown__dropdown',
            this.props.className
          )}
          isDisabled={this.props.isDisabled}
        />
      </div>
    );
  }
}

export default DropdownComponent;
